module.exports = __webpack_public_path__ + "img/report_main1.10b5d80e.png";